import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestAgendarExamesRenovacao } from './types';

// ACTIONS
import {
	agendarExamesRenovacaoSuccess,
	agendarExamesRenovacaoFailure,
} from './actions';

function* agendarExamesRenovacao(request: ReducerAction) {
	const { payload }: { payload: IRequestAgendarExamesRenovacao } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/agendar-exames-renovacao`,
		payload,
	);

	if (response.status === 200) {
		yield put(agendarExamesRenovacaoSuccess(response));
	} else if (response.error) {
		yield put(agendarExamesRenovacaoFailure(response.error));
	}
}

export default all([
	takeLatest(Types.AGENDAR_EXAMES_RENOVACAO, agendarExamesRenovacao),
]);
